export enum TabOptions {
  FOLDERS = 'folders',
  ALL = 'all',
  PACKS = 'packs',
}
